package ru.ivk1800.screen.main

import androidx.compose.runtime.Composable

class MainScreenFactory {
    @Composable
    fun create() {
        MainScreen()
    }
}
